<mat-card>

  <mat-card-title [class.open]="expanded">
    <!-- Keyboard-operable in place: Enter and Space do what a click does, and Space must not also scroll the page. -->
    <div class="container"
         role="button"
         tabindex="0"
         [attr.aria-expanded]="expanded"
         (click)="toggle()"
         (keydown.enter)="toggle()"
         (keydown.space)="$event.preventDefault(); toggle()">
      <div class="title">{{ title }} <span *ngIf="subtitle"> - <span class="subtitle">{{ subtitle }}</span></span></div>
      <div class="controls">
        <mat-icon>{{ expanded ? "expand_less" : "expand_more" }}</mat-icon>
      </div>
    </div>
  </mat-card-title>

  <ng-content *ngIf="expanded"></ng-content>

</mat-card>
